import { GoogleTagManager } from '@next/third-parties/google'
import type { FunctionComponent } from 'react'

export const GTMScript: FunctionComponent = () => {
    if (!process.env.NEXT_PUBLIC_GTM_ID) return null
    return <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID} />
}

export const GTMNoScript: FunctionComponent = () => {
    if (!process.env.GTM_ID) return null
    return (
        <noscript>
            <iframe
                src={`https://www.googletagmanager.com/ns.html?id=${process.env.GTM_ID}`}
                height='0'
                width='0'
                style={{ display: 'none', visibility: 'hidden' }}
            />
        </noscript>
    )
}
